import React from "react";
import { StripeAccountLinkTemplate } from "themes/common/components";

function StripeAccountLink(props) {
    return <StripeAccountLinkTemplate {...props} />;
}

export default StripeAccountLink;
